import React from 'react'
import SideNav from './SideNav'

const OneBHKInteriorDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-one-bhk parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    1BHK Interior Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/one-bhk-interior-design.jpg" alt="1BHK Interior Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Your 1 BHK home may be compact, but with the right design, it
                      can feel spacious, elegant, and perfectly functional. At MeHome,
                      we bring 15+ years of expertise in interior design and
                      construction to transform 1 BHK apartments into dream homes that
                      reflect style, comfort, and smart living.
                    </p>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Creating Big Impact in <span> Small Spaces</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      A 1 BHK requires more than just good design—it needs creative
                      space planning. Our design philosophy focuses on:
                    </p>
                    <ul>
                      <li>Smart Layouts: Maximizing every inch of available space.</li>
                      <li>Multi-Functional Solutions: Furniture and storage that serve more than one purpose.</li>
                      <li>Modern Aesthetics: Sleek, clutter-free designs with contemporary finishes.</li>
                      <li>Personalized Touches: Tailored to your lifestyle, taste, and budget.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Specialized <span> 1 BHK Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🛋️</div>
                        <div className="why-choose-item-content">
                          <h3>Living Room</h3>
                          <p>
                            We design welcoming living spaces that look spacious and
                            feel cozy. From modular TV units and accent walls to
                            elegant lighting, we create a perfect space for relaxation
                            and hosting guests.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🛏️</div>
                        <div className="why-choose-item-content">
                          <h3>Bedroom</h3>
                          <p>
                            A peaceful retreat designed with space-saving wardrobes,
                            stylish interiors, and practical storage. Whether
                            minimalist or luxurious, we make sure your bedroom
                            reflects your personality.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🍳</div>
                        <div className="why-choose-item-content">
                          <h3>Modular Kitchen</h3>
                          <p>
                            Compact yet efficient kitchens with ergonomic layouts,
                            smart storage, and durable finishes. Every design balances
                            functionality with style, making cooking a delightful
                            experience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🚿</div>
                        <div className="why-choose-item-content">
                          <h3>Bathroom &amp; Utility</h3>
                          <p>
                            Functional upgrades with modern fittings, storage
                            solutions, and space optimization techniques for comfort
                            and convenience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🪑</div>
                        <div className="why-choose-item-content">
                          <h3>Custom Furniture &amp; Decor</h3>
                          <p>
                            From multi-purpose sofa-cum-beds to foldable dining
                            tables, we design furniture that fits seamlessly into your
                            1 BHK while adding style and functionality.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why MeHome is Perfect for <span>1 BHK Interior Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>15+ Years of Industry Experience </b>– Trusted by hundreds of happy homeowners.</li>
                        <li><b>Compact Space Experts </b>– Specialized designs for small apartments.</li>
                        <li><b>End-to-End Services </b>– From planning, 3D visualization, and construction to finishing.</li>
                        <li><b>Affordable Luxury </b> – Premium interiors designed within your budget.</li>
                        <li><b>On-Time Execution </b>– Hassle-free project delivery, every time.</li>
                        <li><b>Quality Craftsmanship </b> – Durable materials and flawless workmanship.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default OneBHKInteriorDesigns
